import React from 'react';
import PropTypes from 'prop-types';
import { classNames } from 'utils';
import './IconSVG.scss';

const IconSVG = ({
  name,
  size = 'medium',
  color = 'black',
  background = '',
  additionalClass = '',
  title,
}) => {
  const isAccessible = Boolean(title);

  return (
    <div
      className={classNames(
        'icon-svg__wrapper',
        {
          [`icon-svg--background-${background}`]: background,
          [`icon-svg__wrapper--${size}`]: size,
        },
        additionalClass
      )}
    >
      <svg
        className={classNames('icon-svg', `icon-svg-${name}`, {
          [`icon-svg--color-${color}`]: color,
        })}
        aria-hidden={!isAccessible}
        role={isAccessible ? 'img' : undefined}
      >
        {title && <title>{title}</title>}
        <use href={`/icons-set.svg#icon-${name}`} xlinkHref={`/icons-set.svg#icon-${name}`} />      </svg>
    </div>
  );
};

IconSVG.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
  background: PropTypes.string,
  additionalClass: PropTypes.string,
  title: PropTypes.string,
};

export default IconSVG;
